import { render, staticRenderFns } from "./adopt.vue?vue&type=template&id=f2107672&scoped=true&"
import script from "./adopt.vue?vue&type=script&lang=ts&"
export * from "./adopt.vue?vue&type=script&lang=ts&"
import style0 from "./adopt.vue?vue&type=style&index=0&id=f2107672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2107672",
  null
  
)

export default component.exports